import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./contexts/ContentContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { I18nProvider } from "./i18n/I18nContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Layout } from "./components/Layout";
import { RequireAdmin } from "./components/Shared";

import Home from "./pages/Home";
import Business from "./pages/Business";
import Travel from "./pages/Travel";
import Retreat from "./pages/Retreat";
import Filming from "./pages/Filming";
import Contacts from "./pages/Contacts";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <ThemeProvider>
          <I18nProvider>
            <AuthProvider>
              <BrowserRouter>
                <Toaster position="bottom-right" richColors closeButton />
                <Routes>
                  <Route
                    path="/"
                    element={
                      <Layout>
                        <Home />
                      </Layout>
                    }
                  />
                  <Route
                    path="/business"
                    element={
                      <Layout>
                        <Business />
                      </Layout>
                    }
                  />
                  <Route
                    path="/travel"
                    element={
                      <Layout>
                        <Travel />
                      </Layout>
                    }
                  />
                  <Route
                    path="/retreat"
                    element={
                      <Layout>
                        <Retreat />
                      </Layout>
                    }
                  />
                  <Route
                    path="/filming"
                    element={
                      <Layout>
                        <Filming />
                      </Layout>
                    }
                  />
                  <Route
                    path="/contacts"
                    element={
                      <Layout>
                        <Contacts />
                      </Layout>
                    }
                  />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route
                    path="/admin"
                    element={
                      <RequireAdmin>
                        <AdminDashboard />
                      </RequireAdmin>
                    }
                  />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
            </AuthProvider>
          </I18nProvider>
        </ThemeProvider>
      </ContentProvider>
    </div>
  );
}

export default App;
